var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCherry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6 2.45002C22.7806 2.20926 22.7997 1.88387 22.6487 1.62358C22.4976 1.36328 22.2056 1.21848 21.907 1.25581C19.1388 1.60183 15.0072 2.83981 11.5481 5.45146C9.14993 7.26207 7.06909 9.74064 6.00505 13.0269C3.75264 13.2734 2 15.182 2 17.5C2 19.9853 4.01472 22 6.5 22C8.98528 22 11 19.9853 11 17.5C11 15.3786 9.53206 13.6001 7.55653 13.1247C8.54683 10.3453 10.3554 8.23145 12.4519 6.64858C14.9763 4.74263 17.9101 3.61695 20.2958 3.06761C18.831 5.18185 16.8927 8.50109 16.01 13.0264C13.7552 13.2706 12 15.1803 12 17.5C12 19.9853 14.0147 22 16.5 22C18.9853 22 21 19.9853 21 17.5C21 15.3661 19.5147 13.5791 17.5215 13.1165C18.6119 7.7674 21.2628 4.23295 22.5919 2.46087L22.6 2.45002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCherry);
export default __webpack_public_path__ + "static/media/cherry.ae0682b4107c36fc95ce3dc0bdc2f72b.svg";
export { ForwardRef as ReactComponent };